var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "relative runner_order_list_component": true,
        tableMinWidth: _vm.tableMobileAdaptation,
      },
    },
    [
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.updateNoAnswerCalls,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sendMessageModal.runnerModal
        ? _c("SendRunnerMessage", {
            attrs: {
              data: _vm.sendMessageModal.order,
              type: _vm.sendMessageModal.type,
              onModalClose: () => (_vm.sendMessageModal.runnerModal = false),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "text-right sticky no_print" }, [
        _c(
          "div",
          { class: { sticky_absolute: true } },
          [
            !_vm.runnerId && !_vm.selectedRunner
              ? _c("div", [
                  _c("p", [_vm._v("Выберите курьера для назначения заявок")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.runnerId && _vm.selectedRunner
              ? _c("div", { staticClass: "orders_list" }, [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.getSelectedLabel()) },
                  }),
                  _vm._v(" "),
                  _vm.selectedOrders &&
                  _vm.selectedOrders.orders &&
                  _vm.selectedOrders.orders.length
                    ? _c("div", [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-sm table-hover table_selected_orders",
                          },
                          [
                            _c(
                              "tbody",
                              [
                                _vm._l(_vm.selectedOrders.orders, function (o) {
                                  return _c("tr", { key: o.id }, [
                                    _c("td", [
                                      _vm._v(
                                        "Заявка: " +
                                          _vm._s(_vm.mixinPrintOrderNum(o.id))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            o.price.toLocaleString("ru-RU")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ])
                                }),
                                _vm._v(" "),
                                _c("tr", [
                                  _c("td", { attrs: { colspan: "2" } }, [
                                    _vm._v("\n                  Заявок ("),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.selectedOrders.orders.length)
                                      ),
                                    ]),
                                    _vm._v(") На сумму:\n                  "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedOrders.totalSum.toLocaleString(
                                            "ru-RU"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              2
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.runnerId
              ? _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn btn-sm btn-info",
                      "data-style": "zoom-in",
                      loading: _vm.btnLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.appointOrders()
                      },
                    },
                  },
                  [_vm._v("Назначить заявки\n        ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.runnerId && Number(_vm.runnerId)
              ? _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn btn-sm btn-success",
                      "data-style": "zoom-in",
                      loading: _vm.updateBtnLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setDelivered()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          this.payMethod && this.payMethod === "cod_paid"
                            ? "Отправить"
                            : "Отметить доставленными"
                        ) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.runnerId && _vm.runnerId === "sent"
              ? _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn btn-sm btn-success",
                      "data-style": "zoom-in",
                      loading: _vm.btnLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setClosed()
                      },
                    },
                  },
                  [_vm._v("\n          Отметить доставленными\n        ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.runnerId && _vm.showOptions.allowToResetOrders
              ? _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn btn-sm btn-warning",
                      "data-style": "zoom-in",
                      loading: _vm.btnLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.resetOrders()
                      },
                    },
                  },
                  [_vm._v("Сбросить заявки\n        ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.allowToSort && _vm.useOrderNum
              ? _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn btn-sm btn-info",
                      "data-style": "zoom-in",
                      loading: _vm.btnLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.updateOrders()
                      },
                    },
                  },
                  [_vm._v("Сохранить порядок\n        ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            content_table: true,
            tableMinWidth: _vm.tableMobileAdaptation,
          },
        },
        [
          _c(
            "div",
            {
              class: {
                table_absolute: true,
                tableMinWidth: _vm.tableMobileAdaptation,
              },
            },
            [
              _c(
                "table",
                {
                  class: {
                    "table table-bordered table-hover table-sm": true,
                    "table-order-adoptive": !_vm.tableMobileAdaptation,
                  },
                },
                [
                  _c("thead", { staticClass: "hide_on_mid" }, [
                    _c(
                      "tr",
                      [
                        _c(
                          "th",
                          { staticClass: "no_print", attrs: { width: "30" } },
                          [
                            _vm.runnerId
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectAll,
                                      expression: "selectAll",
                                    },
                                  ],
                                  staticClass: "main_checkbox",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.selectAll)
                                      ? _vm._i(_vm.selectAll, null) > -1
                                      : _vm.selectAll,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = _vm.selectAll,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectAll = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectAll = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectAll = $$c
                                        }
                                      },
                                      _vm.toggleAllCheckboxes,
                                    ],
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "90" } }, [_vm._v("Номер")]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "hide_on_mid",
                            attrs: { width: "170" },
                          },
                          [_vm._v("ФИО")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "hide_on_mid hide_on_mobile_table",
                            attrs: { width: "15%" },
                          },
                          [_vm._v("Адрес")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "hide_on_mid hide_on_small",
                            attrs: { width: "11%" },
                          },
                          [_vm._v("Комментарий")]
                        ),
                        _vm._v(" "),
                        _vm.postOrders && _vm.runnerId
                          ? [
                              _c("th", [_vm._v("Расходы / бандероль")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Скан чека")]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("th", [_vm._v("Препараты")]),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "100" } }, [
                          _vm._v("Сумма"),
                        ]),
                        _vm._v(" "),
                        !_vm.postOrders || _vm.showOptions.allowActions
                          ? _c("th", {
                              staticClass: "no_print",
                              attrs: { width: "100" },
                            })
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.localOrders, function (order, ind) {
                      return _c(
                        "tr",
                        {
                          key: ind,
                          class: { tr_selected: _vm.selected[order.id] },
                          on: {
                            click: function ($event) {
                              return _vm.addToselectedOrders($event, order.id)
                            },
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticClass: "no_print middle_td",
                              attrs: { width: "30" },
                            },
                            [
                              _vm.runnerId || _vm.selectedRunner
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selected[order.id],
                                        expression: "selected[order.id]",
                                      },
                                    ],
                                    staticClass: "select_checkbox",
                                    attrs: {
                                      type: "checkbox",
                                      name: `selected[${order.id}]`,
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.selected[order.id]
                                      )
                                        ? _vm._i(_vm.selected[order.id], null) >
                                          -1
                                        : _vm.selected[order.id],
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.selected[order.id],
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.selected,
                                                order.id,
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.selected,
                                                order.id,
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(_vm.selected, order.id, $$c)
                                        }
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("div", { class: { no_print: true } }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.sortedOrderNum[order.id],
                                      expression: "sortedOrderNum[order.id]",
                                    },
                                  ],
                                  staticClass: "form-control line_input",
                                  attrs: {
                                    type: "number",
                                    name: `orderLine[${order.id}]`,
                                  },
                                  domProps: {
                                    value: _vm.sortedOrderNum[order.id],
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.sortedOrderNum,
                                        order.id,
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                staticClass: "phone_num",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.mixinPrintOrderNum(order.id)
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      (_vm.$AllProjects[order.site_id] &&
                                        _vm.$AllProjects[order.site_id].name) ||
                                        "не определен"
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "badge badge-info" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.moment(order.delivery_date, "DD.MM")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                Создание: " +
                                    _vm._s(
                                      _vm.moment(order.created_at, "DD.MM")
                                    ) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              !_vm.popover[order.id].shift && !_vm.runnerId
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-xs btn-success btn-padding",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          _vm.popover[order.id].shift = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Перенос\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.popover[order.id].shift
                                ? _c(
                                    "v-popover",
                                    {
                                      attrs: {
                                        "auto-hide": true,
                                        open:
                                          _vm.popover[order.id] &&
                                          _vm.popover[order.id].shift,
                                      },
                                      on: {
                                        hide: function ($event) {
                                          return _vm.destroyPopover(order.id)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-xs btn-success btn-padding",
                                          attrs: { type: "button" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Перенос\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "template",
                                        { slot: "popover" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    order.new_delivery_date,
                                                  expression:
                                                    "order.new_delivery_date",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    order,
                                                    "new_delivery_date",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              _vm.getChageDateOptions(
                                                order.delivery_date
                                              ),
                                              function (date) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: date.date,
                                                    domProps: {
                                                      value: date.date,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(date.text) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "vue-ladda",
                                            {
                                              attrs: {
                                                "button-class":
                                                  "btn btn-xs btn-success",
                                                "data-style": "zoom-in",
                                                loading: _vm.updateBtnLoading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updateDeliveryDate(
                                                    order
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "Сохранить\n                  "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c("span", { staticClass: "fs-11" }, [
                              _vm._v(
                                _vm._s(
                                  order.client_name ||
                                    (order.client && order.client.name) ||
                                    "Имя не указано"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "phone_td" },
                              [
                                _vm._l(
                                  order.order_phones &&
                                    order.order_phones.length
                                    ? order.order_phones
                                    : order.phones.map((p) => {
                                        return {
                                          ...p,
                                          phone: {
                                            phone: (
                                              "" + p.full_phone
                                            ).substring(2),
                                          },
                                        }
                                      }),
                                  function (phone) {
                                    return [
                                      phone.phone
                                        ? _c("p", [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "phone_num",
                                                attrs: {
                                                  href: `tel:${_vm.mixinPrintPhone(
                                                    "00" + phone.phone.phone,
                                                    true
                                                  )}`,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.mixinPrintPhone(
                                                      "00" + phone.phone.phone
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                                _vm._v(" "),
                                order.call_yestoday
                                  ? _c("p", { staticClass: "bold_info" }, [
                                      _vm._v(
                                        "\n                  Позвонить за день\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-outline-warning btn-padding",
                                    on: {
                                      click: function ($event) {
                                        return _vm.noAnsverPhoneCall(
                                          order.id,
                                          ""
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v("\n                  Недозвон "),
                                    order.extra_options.noAnswerCallOrder
                                      ? _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                order.extra_options
                                                  .noAnswerCallOrder
                                              ) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            order.credit_card_id
                              ? _c(
                                  "div",
                                  { staticClass: "mt-1" },
                                  [
                                    order.pay_method === 3
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "badge badge-success",
                                            },
                                            [
                                              _vm._v(
                                                "Заявка оплачена на карту - денег с клиента не брать"
                                              ),
                                            ]
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "span",
                                            { staticClass: "badge badge-info" },
                                            [
                                              _vm._v(
                                                "Ожидается предоплата на карту"
                                              ),
                                            ]
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mobileViewPort
                              ? _c(
                                  "div",
                                  { staticClass: "show_mobile no_print" },
                                  [
                                    _c("div", { staticClass: "fs-11" }, [
                                      _c("p", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              (order.city_id &&
                                                _vm.$AllCities[order.city_id] &&
                                                _vm.$AllCities[order.city_id]
                                                  .name) ||
                                                "Почтовая доставка"
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(order.address) +
                                          "\n                  "
                                      ),
                                      order.extra_options.address_details
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                order.extra_options
                                                  .address_details
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.payMethod &&
                                      _vm.payMethod === "cod_paid"
                                        ? _c("div", [
                                            _c("hr"),
                                            _vm._v(
                                              "\n                    отправитель:\n                    "
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "badge badge-light normal-wrap",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.appointedSenders[
                                                      order.sender_id
                                                    ] &&
                                                      _vm.appointedSenders[
                                                        order.sender_id
                                                      ].name) ||
                                                      "не определен"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    order.metro_station
                                      ? _c("div", { staticClass: "flex" }, [
                                          !order.extra_options.manualMetro
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "auto_metro_set",
                                                },
                                                [_vm._m(0, true)]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          order.metro_station &&
                                          order.metro_station.line
                                            ? _c(
                                                "div",
                                                { staticClass: "metro_line" },
                                                [
                                                  _c("p", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "badge",
                                                        style: `background-color:${
                                                          order.metro_station &&
                                                          order.metro_station
                                                            .line &&
                                                          order.metro_station
                                                            .line.color
                                                        }`,
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            order.metro_station
                                                              .line &&
                                                              order
                                                                .metro_station
                                                                .line.number
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          order.metro_station
                                                            .line.title
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-subway",
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          order.metro_station
                                                            .title
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.popover[order.id].metro &&
                                    _vm.metroLines &&
                                    _vm.metroLines.length
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-success btn-padding",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                _vm.popover[
                                                  order.id
                                                ].metro = true
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  указать метро\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.popover[order.id].metro
                                      ? _c(
                                          "v-popover",
                                          {
                                            attrs: {
                                              popoverClass: "metro_select",
                                              open: _vm.popover[order.id].metro,
                                            },
                                            on: {
                                              hide: function ($event) {
                                                return _vm.destroyPopover(
                                                  order.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-xs btn-success btn-padding",
                                                attrs: { type: "button" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    указать метро\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "popover" },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _vm._v(
                                                      "\n                      Выберите станцию метро\n                      "
                                                    ),
                                                    _c(
                                                      "v-select",
                                                      {
                                                        attrs: {
                                                          placeholder:
                                                            "Выберите станцию...",
                                                          options:
                                                            _vm.metroList,
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "option",
                                                              fn: function (
                                                                option
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "badge",
                                                                      style: `background-color: ${option.color}`,
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          option.num
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        option.label
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value:
                                                            _vm.selectedMetroStation,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.selectedMetroStation =
                                                              $$v
                                                          },
                                                          expression:
                                                            "selectedMetroStation",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              slot: "no-options",
                                                            },
                                                            slot: "no-options",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Станция не найден."
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "vue-ladda",
                                                      {
                                                        ref: "saveMetroBtn",
                                                        refInFor: true,
                                                        attrs: {
                                                          "button-class":
                                                            "btn btn-sm btn-outline-success",
                                                          "data-style":
                                                            "zoom-in",
                                                          loading:
                                                            _vm.updateBtnLoading,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.saveMetroLine(
                                                              order.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "сохранить\n                      "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "hide_on_mid" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  [
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            (order.city_id &&
                                              _vm.$AllCities[order.city_id] &&
                                              _vm.$AllCities[order.city_id]
                                                .name) ||
                                              "Почтовая доставка"
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(order.address) +
                                        "\n                  "
                                    ),
                                    order.extra_options.address_details
                                      ? _c("p", { staticClass: "mt-1" }, [
                                          _vm._v(
                                            _vm._s(
                                              order.extra_options
                                                .address_details
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("RunnerSalaryRate", {
                                      attrs: {
                                        rate:
                                          order?.extra_options?.salary_rate ??
                                          0,
                                      },
                                    }),
                                    _vm._v(" "),
                                    order.status === 2
                                      ? _c("div", [
                                          _vm.isClientNoReply(order)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-warning",
                                                },
                                                [_vm._v("У курьера недозвон")]
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.payMethod &&
                                    _vm.payMethod === "cod_paid"
                                      ? _c("div", [
                                          _c("hr"),
                                          _vm._v(
                                            "\n                    отправитель:\n                    "
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "badge badge-light normal-wrap",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  (_vm.appointedSenders[
                                                    order.sender_id
                                                  ] &&
                                                    _vm.appointedSenders[
                                                      order.sender_id
                                                    ].name) ||
                                                    "не определен"
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                order.metro_station
                                  ? _c("div", { staticClass: "flex" }, [
                                      !order.extra_options.manualMetro
                                        ? _c(
                                            "div",
                                            { staticClass: "auto_metro_set" },
                                            [_vm._m(1, true)]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      order.metro_station &&
                                      order.metro_station.line
                                        ? _c(
                                            "div",
                                            { staticClass: "metro_line" },
                                            [
                                              _c("p", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "badge",
                                                    style: `background-color:${order?.metro_station?.line.color}`,
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        order.metro_station
                                                          .line &&
                                                          order.metro_station
                                                            .line.number
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      order.metro_station.line
                                                        .title
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-subway",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      order.metro_station.title
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.popover[order.id].metro &&
                                _vm.metroLines &&
                                _vm.metroLines.length
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-xs btn-success btn-padding",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            _vm.popover[order.id].metro = true
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  указать метро\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.popover[order.id].metro
                                  ? _c(
                                      "v-popover",
                                      {
                                        attrs: {
                                          popoverClass: "metro_select",
                                          open: _vm.popover[order.id].metro,
                                        },
                                        on: {
                                          hide: function ($event) {
                                            return _vm.destroyPopover(order.id)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-success btn-padding",
                                            attrs: { type: "button" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    указать метро\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("template", { slot: "popover" }, [
                                          _c(
                                            "div",
                                            [
                                              _vm._v(
                                                "\n                      Выберите станцию метро\n                      "
                                              ),
                                              _c(
                                                "v-select",
                                                {
                                                  attrs: {
                                                    placeholder:
                                                      "Выберите станцию...",
                                                    options: _vm.metroList,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "option",
                                                        fn: function (option) {
                                                          return [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "badge",
                                                                style: `background-color: ${option.color}`,
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    option.num
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  option.label
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value:
                                                      _vm.selectedMetroStation,
                                                    callback: function ($$v) {
                                                      _vm.selectedMetroStation =
                                                        $$v
                                                    },
                                                    expression:
                                                      "selectedMetroStation",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        slot: "no-options",
                                                      },
                                                      slot: "no-options",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Станция не найден."
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "vue-ladda",
                                                {
                                                  ref: "saveMetroBtn",
                                                  refInFor: true,
                                                  attrs: {
                                                    "button-class":
                                                      "btn btn-sm btn-outline-success",
                                                    "data-style": "zoom-in",
                                                    loading:
                                                      _vm.updateBtnLoading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.saveMetroLine(
                                                        order.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "сохранить\n                      "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-right" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-xs btn-outline-info",
                                      on: {
                                        click: function ($event) {
                                          return _vm.sendTelegramMessage(
                                            order,
                                            "runner"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-motorcycle chat_icon",
                                      }),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "hide_on_small" }, [
                            _c("div", [
                              _c("div", { staticClass: "comment_block" }, [
                                order.extra_options.comments_for_runner &&
                                order.extra_options.comments_for_runner.length
                                  ? _c(
                                      "div",
                                      [
                                        _vm._l(
                                          order.extra_options
                                            .comments_for_runner,
                                          function (comment, indd) {
                                            return _c("div", {
                                              key: indd,
                                              domProps: {
                                                innerHTML: _vm._s(comment.text),
                                              },
                                            })
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "comment_author" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.moment(
                                                  order.extra_options
                                                    .comments_for_runner[0]
                                                    .created_at,
                                                  "DD.MM"
                                                )
                                              ) +
                                                " -\n                      " +
                                                _vm._s(
                                                  _vm.moment(
                                                    order.extra_options
                                                      .comments_for_runner[
                                                      order.extra_options
                                                        .comments_for_runner
                                                        .length - 1
                                                    ].created_at,
                                                    "DD.MM"
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-right" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: order.new_chief_runner_comment,
                                    expression:
                                      "order.new_chief_runner_comment",
                                  },
                                ],
                                staticClass:
                                  "form-control comment_text_area no_print",
                                attrs: {
                                  rows: "3",
                                  p1laceholder: "Комментарий к заявке",
                                },
                                domProps: {
                                  value: order.new_chief_runner_comment,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      order,
                                      "new_chief_runner_comment",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-xs btn-outline-success btn-padding",
                                  attrs: {
                                    disabled:
                                      !!_vm.globalLoading[order.id]
                                        .savingComment,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addComment(order)
                                    },
                                  },
                                },
                                [
                                  _vm.globalLoading[order.id].savingComment
                                    ? [
                                        _c("scale-loader", {
                                          attrs: {
                                            loading: true,
                                            color: "white",
                                            height: "12px",
                                          },
                                        }),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                    Сохранить\n                  "
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.postOrders && _vm.runnerId
                            ? [
                                _c("td", [
                                  _c(
                                    "div",
                                    { staticClass: "post_data_block" },
                                    [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Расходы"),
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.ordersExtraOptions[order.id]
                                                  .post_sum,
                                              expression:
                                                "ordersExtraOptions[order.id].post_sum",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            disabled:
                                              !_vm.showOptions.editExpenses,
                                            type: "number",
                                          },
                                          domProps: {
                                            value:
                                              _vm.ordersExtraOptions[order.id]
                                                .post_sum,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.ordersExtraOptions[
                                                  order.id
                                                ],
                                                "post_sum",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Бандероль"),
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.ordersExtraOptions[order.id]
                                                  .track_number,
                                              expression:
                                                "ordersExtraOptions[order.id].track_number",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            disabled:
                                              !_vm.showOptions.editTrackNum,
                                          },
                                          domProps: {
                                            value:
                                              _vm.ordersExtraOptions[order.id]
                                                .track_number,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.ordersExtraOptions[
                                                  order.id
                                                ],
                                                "track_number",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("VerticalUploadFile", {
                                      attrs: {
                                        orderId: order.id,
                                        autoSave: true,
                                        type: "postTrack",
                                        disableUpload:
                                          !_vm.showOptions.uploadImage,
                                        uploadedKey:
                                          order.extra_options
                                            .post_track_image || false,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              class: `tr_status_${
                                _vm.storeStatusByOrders[order.id] &&
                                _vm.storeStatusByOrders[order.id].status
                              } fs-11`,
                            },
                            [
                              _vm._l(order.details, function (p, index3) {
                                return _c("div", { key: index3 }, [
                                  index3 !== 0 ? _c("hr") : _vm._e(),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        p.qty / (p.new_drug.pack_set || 1)
                                      ) +
                                        "шт - " +
                                        _vm._s(p.new_drug.title) +
                                        " (" +
                                        _vm._s(p.drug_id) +
                                        ")"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      p.new_drug.cool
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "alert cool_condition m-0 p-1 mb-1",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Доставка с хладогеном\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      p.new_drug.pack_set &&
                                      +p.new_drug.pack_set > 1
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert alert-danger m-0 p-1 mb-1",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      p.qty /
                                                        (p.new_drug.pack_set ||
                                                          1)
                                                    ) +
                                                    " компл. (" +
                                                    _vm._s(p.qty) +
                                                    " завод.упак.)\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex pack_details_block",
                                        },
                                        [
                                          p.new_drug.pack_comment
                                            ? [
                                                _c("div", [
                                                  _c("i", {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName: "v-tooltip",
                                                        value: {
                                                          content:
                                                            p.new_drug
                                                              .pack_comment,
                                                          placement:
                                                            "bottom-center",
                                                          classes: ["info"],
                                                          targetClasses: [
                                                            "it-has-a-tooltip",
                                                          ],
                                                          offset: 20,
                                                          delay: {
                                                            show: 500,
                                                            hide: 300,
                                                          },
                                                        },
                                                        expression:
                                                          "{\n                        content: p.new_drug.pack_comment,\n                        placement: 'bottom-center',\n                        classes: ['info'],\n                        targetClasses: ['it-has-a-tooltip'],\n                        offset: 20,\n                        delay: {\n                          show: 500,\n                          hide: 300\n                        }\n                      }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "icon-fa icon-fa-info-circle",
                                                  }),
                                                ]),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          p.new_drug.pack_box_comment
                                            ? [
                                                _c("i", {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: {
                                                        content:
                                                          p.new_drug
                                                            .pack_box_comment,
                                                        placement:
                                                          "bottom-center",
                                                        classes: ["info"],
                                                        targetClasses: [
                                                          "it-has-a-tooltip",
                                                        ],
                                                        offset: 20,
                                                        delay: {
                                                          show: 500,
                                                          hide: 300,
                                                        },
                                                      },
                                                      expression:
                                                        "{\n                      content: p.new_drug.pack_box_comment,\n                      placement: 'bottom-center',\n                      classes: ['info'],\n                      targetClasses: ['it-has-a-tooltip'],\n                      offset: 20,\n                      delay: {\n                        show: 500,\n                        hide: 300\n                      }\n                    }",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "icon-fa icon-fa-home",
                                                }),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-popover",
                                            {
                                              attrs: {
                                                trigger: "click",
                                                delay: { show: 100, hide: 100 },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-image pointer",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.loadDrugImage(
                                                      p.new_drug.id,
                                                      order.site_id
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "popover" },
                                                [
                                                  _c(
                                                    "div",
                                                    [
                                                      _c("clip-loader", {
                                                        attrs: {
                                                          loading:
                                                            _vm.imageLoading[
                                                              p.new_drug.id
                                                            ],
                                                          color:
                                                            _vm.$constants
                                                              .LOADING_COLOR,
                                                          size: "20px",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      !_vm.imageLoading[
                                                        p.new_drug.id
                                                      ]
                                                        ? [
                                                            _vm.drugImages?.[
                                                              p.new_drug.id
                                                            ]?.[order.site_id]
                                                              ? _c("div", [
                                                                  _c("img", {
                                                                    attrs: {
                                                                      src: _vm
                                                                        .drugImages[
                                                                        p
                                                                          .new_drug
                                                                          .id
                                                                      ][
                                                                        order
                                                                          .site_id
                                                                      ].image,
                                                                    },
                                                                  }),
                                                                ])
                                                              : _c("div", [
                                                                  _vm._v(
                                                                    "\n                              Фото не найдено\n                            "
                                                                  ),
                                                                ]),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    2
                                  ),
                                ])
                              }),
                              _vm._v(" "),
                              order.type_id === 2 && order.related_order
                                ? _c("div", [
                                    _vm._v("\n                Курьер: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(order.related_order.courier_name)
                                      ),
                                    ]),
                                    _vm._v(
                                      " (" +
                                        _vm._s(
                                          order.related_order.report_date
                                        ) +
                                        ")\n              "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "show_on_small no_print" },
                                [
                                  _c("div", { staticClass: "text-right" }, [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: order.new_chief_runner_comment,
                                          expression:
                                            "order.new_chief_runner_comment",
                                        },
                                      ],
                                      staticClass:
                                        "form-control comment_text_area no_print",
                                      attrs: {
                                        rows: "2",
                                        p1laceholder: "Комментарий к заявке",
                                      },
                                      domProps: {
                                        value: order.new_chief_runner_comment,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            order,
                                            "new_chief_runner_comment",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-xs btn-outline-success btn-padding",
                                        attrs: {
                                          disabled:
                                            !!_vm.globalLoading[order.id]
                                              .savingComment,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addComment(order)
                                          },
                                        },
                                      },
                                      [
                                        _vm.globalLoading[order.id]
                                          .savingComment
                                          ? [
                                              _c("scale-loader", {
                                                attrs: {
                                                  loading: true,
                                                  color: "white",
                                                  height: "12px",
                                                },
                                              }),
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                      Сохранить\n                    "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-1" },
                                [
                                  _c("UploadFile", {
                                    attrs: {
                                      "order-id": order.id,
                                      type: "runnersFile",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "price_block" }, [
                              order.pay_method === 3
                                ? _c("p", [_c("strong", [_vm._v("0")])])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "p",
                                { class: { cross: order.pay_method === 3 } },
                                [_vm._v(_vm._s(_vm.printSumm(order)))]
                              ),
                            ]),
                            _vm._v(" "),
                            order.type_id === 2
                              ? _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "badge badge-warning" },
                                    [_vm._v("возврат")]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", {}, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-xs btn-outline-info",
                                  on: {
                                    click: function ($event) {
                                      return _vm.sendTelegramMessage(
                                        order,
                                        "manager"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  вопрос менеджеру\n                  "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          !_vm.postOrders || _vm.showOptions.allowReject
                            ? _c(
                                "td",
                                {
                                  staticClass: "no_print text-right",
                                  staticStyle: { "vertical-align": "bottom" },
                                  attrs: { width: "100" },
                                },
                                [
                                  !_vm.popover[order.id].reject
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-sm btn-warning btn-padding",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              _vm.popover[
                                                order.id
                                              ].reject = true
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Отменить\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.popover[order.id].reject
                                    ? _c(
                                        "v-popover",
                                        {
                                          attrs: {
                                            "auto-hide": true,
                                            popoverClass:
                                              "reject_reason_popover",
                                            open: _vm.popover[order.id].reject,
                                          },
                                          on: {
                                            hide: function ($event) {
                                              return _vm.destroyPopover(
                                                order.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-warning btn-padding",
                                              attrs: { type: "button" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Отменить\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("template", { slot: "popover" }, [
                                            _c(
                                              "div",
                                              [
                                                _vm.showOptions
                                                  .extraExpensesRequire
                                                  ? _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            order.reject_expenses,
                                                          expression:
                                                            "order.reject_expenses",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "number",
                                                        placeholder: "Расходы",
                                                      },
                                                      domProps: {
                                                        value:
                                                          order.reject_expenses,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            order,
                                                            "reject_expenses",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        order.reject_reason,
                                                      expression:
                                                        "order.reject_reason",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    placeholder:
                                                      "Причина отказа",
                                                  },
                                                  domProps: {
                                                    value: order.reject_reason,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        order,
                                                        "reject_reason",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "vue-ladda",
                                                  {
                                                    attrs: {
                                                      "button-class":
                                                        "btn btn-sm btn-warning",
                                                      "data-style": "zoom-in",
                                                      loading:
                                                        _vm.updateBtnLoading,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.rejectOrder(
                                                          order
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Подтвердить\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.runnerId
                ? _c("div", { staticClass: "total_tr text-right" }, [
                    _vm._v("\n          ИТОГО:\n          "),
                    _c("strong", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.getOrdersSum()) +
                          "\n          "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_c("i", { staticClass: "icon-fa icon-fa-android" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_c("i", { staticClass: "icon-fa icon-fa-android" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }